import React from "react";
import Dropdown from "../../../../Main/Dropdown/Dropdown";
import { SettingsType } from "../../../Write";

type Props = {
    values: SettingsType;
    setValues: (arg: SettingsType) => void;
};

const Tab3: React.FC<Props> = ({ values, setValues }) => {
    return (
        <main style={{ display: "block" }}>
            <p className="input_title" style={{ marginBottom: "10px" }}>
                What happens at the end of the story
            </p>
            <textarea
                style={{ marginBottom: "20px" }}
                value={values.storyEnding}
                onChange={(e) =>
                    setValues({ ...values, storyEnding: e.target.value })
                }
            />
            <div className="horizontal_divider"></div>
            <div className="flex_input">
                <p className="input_title">
                    Will the protagonist succeed in reaching the goal at the end
                    of this story?
                </p>
                <Dropdown title={values.goalSuccess || "Select"}>
                    <ul>
                        {["Yes", "No"].map((val, idx) => (
                            <li
                                key={idx}
                                onClick={() =>
                                    setValues({ ...values, goalSuccess: val })
                                }
                            >
                                {val}
                            </li>
                        ))}
                    </ul>
                </Dropdown>
            </div>
            <div className="horizontal_divider"></div>
        </main>
    );
};

export default Tab3;
